// Minimal jQuery plugin matching Bootstrap 3's $.fn.modal API.
// Drop-in replacement that preserves the class transitions and events
// consumed by DialogModal and FrontRoyalApiErrorHandler.
/* global jQuery */
(function ($) {
    const TRANSITION_DURATION = 300;

    class Modal {
        constructor(element) {
            this.element = element;
            this.$element = $(element);
            this._dismissBound = false;
            this._isShown = false;
        }

        show() {
            this._isShown = true;
            document.body.classList.add('modal-open');
            this.$element.css('display', 'block');
            // Force reflow so the transition from opacity 0 → 1 fires
            // oxlint-disable-next-line no-void
            void this.element.offsetHeight;
            this.$element.addClass('in');
            if (!this._dismissBound) {
                this.$element.on('click.fr.modal.dismiss', '[data-dismiss="modal"]', () => this.hide());
                this._dismissBound = true;
            }
        }

        hide() {
            if (!this._isShown) return;
            this._isShown = false;
            this.$element.removeClass('in');
            const afterHide = () => {
                this.$element.css('display', '');
                document.body.classList.remove('modal-open');
                // Re-add modal-open if other modals are still visible
                if ($('.modal.in').length > 0) {
                    document.body.classList.add('modal-open');
                }
                this.$element.trigger('hidden.bs.modal');
            };
            // When transitions are disabled (e.g. in tests), fire synchronously
            if ($.support.transition === false) {
                afterHide();
            } else {
                setTimeout(afterHide, TRANSITION_DURATION);
            }
        }

        destroy() {
            this.$element.off('click.fr.modal.dismiss');
            this.$element.removeData('fr.modal');
        }
    }

    $.fn.modal = function (option) {
        return this.each(function () {
            let data = $(this).data('fr.modal');

            if (!data) {
                data = new Modal(this);
                $(this).data('fr.modal', data);
            }

            if (typeof option === 'string') {
                data[option]();
            } else if (option && option.show) {
                data.show();
            }
        });
    };
})(jQuery);
